export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const money = (n = 0) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n);

let refreshing = null;

const silentRefresh = () => {
  refreshing = refreshing || fetch(`${API}/auth/refresh`, { method: "POST", credentials: "include" })
    .then((r) => r.ok)
    .catch(() => false)
    .finally(() => { refreshing = null; });
  return refreshing;
};

export const api = async (path, options = {}, _retried = false) => {
  const r = await fetch(`${API}${path}`, { credentials: "include", headers: { "Content-Type": "application/json", ...(options.headers || {}) }, ...options });
  const noRefresh = ["/auth/refresh", "/auth/login", "/auth/verify-otp", "/auth/logout"].some((p) => path.startsWith(p));
  if (r.status === 401 && !_retried && !noRefresh) {
    if (await silentRefresh()) return api(path, options, true);
  }
  if (r.status === 403) {
    const clone = await r.clone().json().catch(() => ({}));
    if ((clone.detail || "").includes("ditangguhkan")) {
      sessionStorage.setItem("auth_notice", clone.detail);
      await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" }).catch(() => {});
      window.location.reload();
      throw new Error(clone.detail);
    }
  }
  if (!r.ok) throw new Error((await r.json()).detail || "Terjadi kesalahan");
  return r.json();
};

export const apiDownload = async (path, filename) => {
  let r = await fetch(`${API}${path}`, { credentials: "include" });
  if (r.status === 401 && (await silentRefresh())) {
    r = await fetch(`${API}${path}`, { credentials: "include" });
  }
  if (!r.ok) throw new Error("Gagal mengunduh file");
  const blob = await r.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
};
